module.exports = __webpack_public_path__ + "static/media/marker_ToDo.33a80374.png";